module.exports = __webpack_public_path__ + "static/media/React.c3fbd71b.svg";